import { combineReducers } from "redux";

import { locationsDetails } from "./reducer.locations"
const locationsReducers = combineReducers({
  locationsDetails
})
export default locationsReducers;
